import { AuditingTable } from "components/auditing";
import PropTypes from "prop-types";
import React, { useState }  from "react";
import { DocumentsService } from "services/DocumentsService";

export function DocumentTypeHistory({ documentTypeId }) {
    const noDataMessage = "It looks like no previous changes have been made to the document type.";
    const [tableData, setTableData] = useState(null);
    const [tableRecordCount, setTableRecordCount] = useState(0);

    const onTableChange = (pageSize, pageNumber, startDate, endDate) => {
        DocumentsService.getDocumentTypeChangeLog(documentTypeId, pageSize, pageNumber, startDate, endDate).then(r => {
            setTableData(r.data);
            setTableRecordCount(r.totalCount);
        });
    }

    return (
        <AuditingTable 
            data={tableData}
            totalCount={tableRecordCount}
            onChange={onTableChange}
            allowClear={false}
            noDataMessage={noDataMessage}>
        </AuditingTable>
    );
}

DocumentTypeHistory.propTypes = {
  documentTypeId: PropTypes.string.isRequired
};